// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__3yIKi","Crumb":"Breadcrumbs_Crumb__aBP5K","last":"Breadcrumbs_last__l8kpG","all-but-first":"Breadcrumbs_all-but-first__1yno5"};